import { InitialBridgeContext, IInteropBridge, ClientType } from './types';

export class AndroidBridgeImpl implements IInteropBridge {
  public clientType: ClientType = ClientType.Android;

  public getInitialBridgeContext(): Promise<InitialBridgeContext> {
    try {
      const bridgeContext = JSON.parse(window.Android.getInitialBridgeContextJson());
      return Promise.resolve(bridgeContext);
    } catch (e) {
      return Promise.reject(e);
    }
  }

  public launchAccountPage(): void {
    window.Android.launchAccountPage();
  }

  public launchEComm(path: string): void {
    window.Android.launchEComm(path);
  }

  public launchExternalWeb(url: string): void {
    window.Android.launchExternalWeb(url);
  }

  public launchNativeSignIn(): void {
    window.Android.launchNativeSignIn();
  }

  public launchNativeSignUp(): void {
    window.Android.launchNativeSignUp();
  }

  public launchPhoneCall(tel: string): void {
    window.Android.launchPhoneCall(tel);
  }

  public launchLeaveFeedback(): void {
    window.Android.launchLeaveFeedback();
  }

  public launchNativeMyPurchasesModal(): void {
    window.Android.launchNativeMyPurchasesModal();
  }

  public launchNativeMyPassAndBenefitsModal(): void {
    window.Android.launchNativeMyPassAndBenefitsModal();
  }

  public launchBilling(): void {
    window.Android.launchBilling();
  }
}
